<template>
    <div>
        <v-card flat class="mb-4">
            <v-tabs v-model="listMode" background-color="transparent" color="primary" @change="onListModeChange">
                <v-tab>Все новости</v-tab>
                <v-tab>Отложенные публикации</v-tab>
            </v-tabs>
        </v-card>
        <v-card-title>
            <v-checkbox label="Показать скрытые новости" v-model="onlyHidden" @change="getList()"></v-checkbox>
            <v-chip
                v-if="onlyPostponed"
                color="orange lighten-4"
                text-color="orange darken-4"
                class="ml-4"
            >
                Раздел: Отложенные публикации
            </v-chip>
            <v-spacer></v-spacer>
            <v-text-field
                v-model="query"
                append-icon="$search"
                label="Поиск"
                single-line
                hide-details
                @input="search"
            ></v-text-field>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="list"
            :items-per-page="-1"
            class="elevation-1"
            :loading="loading"
            :options.sync="options"
            page.sync="1"
            loading-text="Загрузка..."
            :server-items-length="totalCount"
            :footer-props="{
            itemsPerPageOptions: [10, 50, 100, 150],
            disableItemsPerPage: false,
            'items-per-page-text':'Элементов на странице:',
            'items-per-page-all-text':'Все'
            }"
        >
            <template #[`item.name`]="{ item }">
                <div>
                    <v-icon
                        v-if="item.exclusive && item.exclusiveStatus == 1"
                        small
                        class="mr-2"
                        color="orange darken-1"
                        title="«Другие новости» требуют модерации"
                    >
                    $info
                    </v-icon>
                    <v-icon
                        v-if="item.exclusive && item.exclusiveStatus == 3"
                        small
                        class="mr-2"
                        color="red darken-1"
                        title="«Другие новости» не прошли модерацию"
                >
                    $info
                    </v-icon>
                    <v-chip
                        v-if="item.postpone"
                        x-small
                        color="orange lighten-4"
                        text-color="orange darken-4"
                        class="mr-2"
                    >
                        Отложена
                    </v-chip>
                    {{ item.name }}
                </div>
            </template>
            <template #[`item.postpone`]="{ item }">
                <v-simple-checkbox
                    v-model="item.postpone"
                    disabled
                ></v-simple-checkbox>
            </template>

            <template #[`item.indexShow`]="{ item }">
                <v-simple-checkbox
                    v-model="item.indexShow"
                    disabled
                ></v-simple-checkbox>
            </template>

            <template v-slot:top>
                <v-dialog
                v-model="dialogEdit"
                persistent
                scrollable
                max-width="900px"
                content-class="news-edit-dialog"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                        color="primary"
                        dark
                        class="mb-2"
                        v-bind="attrs"
                        v-on="on"
                        >
                        Добавить новость
                        </v-btn>
                    </template>
                    
                    <v-card class="news-edit-dialog-card">
                        <v-card-title>
                            <span class="text-h5">{{ formTitle }}</span>
                        </v-card-title>

                        <v-tabs v-model="curTab" background-color="transparent" color="basil" grow>
                            <v-tab>Анонс</v-tab>
                            <v-tab>Контент</v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="curTab" class="news-edit-dialog-content">
                            <v-tab-item>
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <v-text-field
                                            required
                                            label="Заголовок"
                                            autocomplete="nope"
                                            class="news-title-field"
                                            hide-details="auto"
                                            v-model="editedItem.name"
                                        ></v-text-field>
                                    </v-card-text>
                                </v-card>
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <!-- Две строки вместо стандартных пяти: в описании не больше 135 символов,
                                             больше и не нужно. auto-grow — на случай длинного текста. -->
                                        <v-textarea v-model="editedItem.description" label="Краткое описание" hint="*Не больше 135 символов" rows="2" auto-grow hide-details="auto"></v-textarea>
                                    </v-card-text>
                                </v-card>
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <v-select label="Теги" v-model="editedItem.tags" :items="tags" :menu-props="{ maxHeight: '400' }" multiple persistent-hint item-text="name" item-value="id" hide-details="auto"></v-select>
                                    </v-card-text>
                                </v-card>
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <v-file-input label="Картинка анонса (рекомендуем загружать не менее 1200x700px)" accept="image/jpeg, image/png" :clearable="false" v-model="editedItem.newPreview" hide-details="auto"></v-file-input>
                                        <div class="d-flex flex-column justify-space-between align-center" v-if="editedItem.preview">
                                            <v-img
                                                :src="$store.state.api + editedItem.preview"
                                                max-height="200"
                                                :contain="true"
                                            />
                                        </div>
                                        <v-text-field
                                            v-if="editedItem.newPreview || editedItem.preview"
                                            label="Подпись к фото"
                                            hide-details="auto"
                                            v-model="editedItem.previewCaption"
                                        ></v-text-field>
                                    </v-card-text>
                                </v-card>
                                <v-card v-if="cityFeatureEnabled" color="basil" flat>
                                    <v-card-text>
                                        <v-select label="Города" v-model="editedItem.cities" :items="cities" :menu-props="{ maxHeight: '400' }" multiple persistent-hint item-text="name" item-value="id" hide-details="auto"></v-select>
                                    </v-card-text>
                                </v-card>
                                <!-- Пять флагов одной строкой; на узком экране переносятся.
                                     «Главное» и «Другие новости» — признаки вывода: наполняют одноимённые
                                     карусели на главной, никаких условий не требуют.
                                     «Эксклюзив» — авторский материал: идёт на модерацию (статус проставляет
                                     api), автор обязателен всегда, аватар — при создании. Флаги независимы:
                                     эксклюзив попадёт в карусель, только если отмечен и второй. -->
                                <v-card color="basil" flat>
                                    <v-card-text class="d-flex flex-wrap news-flags">
                                        <v-checkbox label="Скрыть новость?" v-model="editedItem.hide" hide-details></v-checkbox>
                                        <v-checkbox label="Отложенная публикация" v-model="editedItem.postpone" hide-details @change="resetDate()"></v-checkbox>
                                        <v-checkbox label="Главное" v-model="editedItem.indexShow" hide-details></v-checkbox>
                                        <v-checkbox label="Другие новости" v-model="editedItem.otherNews" hide-details></v-checkbox>
                                        <v-checkbox label="Эксклюзив" v-model="editedItem.exclusive" hide-details></v-checkbox>
                                    </v-card-text>
                                </v-card>
                                <v-card v-if="editedItem.postpone" color="basil" flat>
                                    <v-card-text>
                                        <v-dialog
                                            ref="dialog"
                                            v-model="datePubDialog"
                                            :return-value.sync="editedItem.datePub"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                    v-model="getPostponeDate"
                                                    label="Дата публикации"
                                                    prepend-icon="$calendar"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                             <v-card color="basil" flat>
                                                <v-card-title>
                                                    <date-picker
                                                        v-model="editedItem.datePub"
                                                        mode="dateTime"
                                                        :timezone="editedItem.timezone"
                                                        :masks='{ input:["L", "YYYY-MM-DD", "YYYY/MM/DD"] }'
                                                        class="date-picker"
                                                        locale="ru-RU"
                                                        is24hr
                                                    />
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="datePubDialog = false"
                                                    >
                                                        Отмена
                                                    </v-btn>
                                                    <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.dialog.save(editedItem.datePub)"
                                                    >
                                                        Ок
                                                    </v-btn>
                                                </v-card-text>
                                            </v-card>
                                        </v-dialog>
                                    </v-card-text>
                                </v-card>
                                <v-card v-if="editedItem.exclusive" color="basil" flat>
                                    <v-card-text>
                                        <v-text-field
                                            :required="editedItem.exclusive"
                                            label="Автор"
                                            autocomplete="nope"
                                            hide-details="auto"
                                            v-model="editedItem.creator"
                                        ></v-text-field>
                                    </v-card-text>
                                    <v-card-text>
                                        <v-file-input
                                            :required="editedItem.exclusive && editedIndex == -1"
                                            label="Аватар автора(64х64px)"
                                            accept="image/jpeg, image/png"
                                            :clearable="false"
                                            v-model="editedItem.newAvatar"
                                            hide-details="auto">
                                        </v-file-input>
                                        <div class="d-flex flex-column justify-space-between align-center" v-if="editedItem.avatar">
                                            <v-img
                                                :src="$store.state.api + editedItem.avatar"
                                                max-height="64"
                                                :contain="true"
                                            />
                                        </div>
                                    </v-card-text>
                                </v-card>
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <v-dialog
                                            v-model="dialogSource"
                                            persistent
                                            max-width="600px"
                                            >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    color="primary"
                                                    dark
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click="onOpenSource"
                                                >
                                                Источник
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title>
                                                <span class="text-h5">Источник</span>
                                                </v-card-title>
                                                <v-card-text>
                                                    <v-container>
                                                        <v-text-field
                                                            v-model="editedItem.source.text"
                                                            label="Текст ссылки"
                                                            required
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="editedItem.source.link"
                                                            label="Ссылка"
                                                            required
                                                        ></v-text-field>
                                                    </v-container>
                                                </v-card-text>
                                                <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="blue darken-1"
                                                    text
                                                    @click="onCancelSource"
                                                >
                                                    Отмена
                                                </v-btn>
                                                <v-btn
                                                    color="blue darken-1"
                                                    text
                                                    @click="dialogSource = false"
                                                >
                                                    Сохранить
                                                </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                            </v-dialog>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card color="basil" flat>
                                    <v-card-text>
                                        <content-editor :list.sync="editedItem.content"></content-editor>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs-items>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <!-- mr-6 даёт те же 12px, что и зазор между «Модерацией» и «Отменой»
                                 (у кнопок свои отступы, поэтому класс на два шага больше). -->
                            <div v-if="canShareEditedNews" class="social-share-row mr-6">
                                <button
                                    type="button"
                                    :class="['share-link', 'share-link--brand-vk', 'social-publish-btn', `share-link--${socialIconStatus('vk')}`]"
                                    title="Опубликовать в VK"
                                    aria-label="Опубликовать в VK"
                                    @click="openSocialDialog('vk')"
                                >
                                    <svg class="share-link__icon" viewBox="0 0 24 24" aria-hidden="true">
                                        <path fill="currentColor" d="m9.489.004.729-.003h3.564l.73.003.914.01.433.007.418.011.403.014.388.016.374.021.36.025.345.03.333.033c1.74.196 2.933.616 3.833 1.516.9.9 1.32 2.092 1.516 3.833l.034.333.029.346.025.36.02.373.025.588.012.41.013.644.009.915.004.98-.001 3.313-.003.73-.01.914-.007.433-.011.418-.014.403-.016.388-.021.374-.025.36-.03.345-.033.333c-.196 1.74-.616 2.933-1.516 3.833-.9.9-2.092 1.32-3.833 1.516l-.333.034-.346.029-.36.025-.373.02-.588.025-.41.012-.644.013-.915.009-.98.004-3.313-.001-.73-.003-.914-.01-.433-.007-.418-.011-.403-.014-.388-.016-.374-.021-.36-.025-.345-.03-.333-.033c-1.74-.196-2.933-.616-3.833-1.516-.9-.9-1.32-2.092-1.516-3.833l-.034-.333-.029-.346-.025-.36-.02-.373-.025-.588-.012-.41-.013-.644-.009-.915-.004-.98.001-3.313.003-.73.01-.914.007-.433.011-.418.014-.403.016-.388.021-.374.025-.36.03-.345.033-.333c.196-1.74.616-2.933 1.516-3.833.9-.9 2.092-1.32 3.833-1.516l.333-.034.346-.029.36-.025.373-.02.588-.025.41-.012.644-.013.915-.009ZM6.79 7.3H4.05c.13 6.24 3.25 9.99 8.72 9.99h.31v-3.57c2.01.2 3.53 1.67 4.14 3.57h2.84c-.78-2.84-2.83-4.41-4.11-5.01 1.28-.74 3.08-2.54 3.51-4.98h-2.58c-.56 1.98-2.22 3.78-3.8 3.95V7.3H10.5v6.92c-1.6-.4-3.62-2.34-3.71-6.92Z"/>
                                    </svg>
                                </button>
                                <button
                                    type="button"
                                    :class="['share-link', 'share-link--brand-telegram', 'social-publish-btn', `share-link--${socialIconStatus('telegram')}`]"
                                    title="Опубликовать в Telegram"
                                    aria-label="Опубликовать в Telegram"
                                    @click="openSocialDialog('telegram')"
                                >
                                    <svg class="share-link__icon" viewBox="0 0 24 24" aria-hidden="true">
                                        <path fill="currentColor" d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                                    </svg>
                                </button>
                                <button
                                    type="button"
                                    :class="['share-link', 'share-link--brand-ok', 'social-publish-btn', `share-link--${socialIconStatus('ok')}`]"
                                    title="Опубликовать в Одноклассниках"
                                    aria-label="Опубликовать в Одноклассниках"
                                    @click="openSocialDialog('ok')"
                                >
                                    <svg class="share-link__icon" viewBox="0 0 24 24" aria-hidden="true">
                                        <path fill="currentColor" d="M12 0a6.2 6.2 0 0 0-6.194 6.195 6.2 6.2 0 0 0 6.195 6.192 6.2 6.2 0 0 0 6.193-6.192A6.2 6.2 0 0 0 12.001 0zm0 3.63a2.567 2.567 0 0 1 2.565 2.565 2.568 2.568 0 0 1-2.564 2.564 2.568 2.568 0 0 1-2.565-2.564 2.567 2.567 0 0 1 2.565-2.564zM6.807 12.6a1.814 1.814 0 0 0-.91 3.35 11.611 11.611 0 0 0 3.597 1.49l-3.462 3.463a1.815 1.815 0 0 0 2.567 2.566L12 20.066l3.405 3.403a1.813 1.813 0 0 0 2.564 0c.71-.709.71-1.858 0-2.566l-3.462-3.462a11.593 11.593 0 0 0 3.596-1.49 1.814 1.814 0 1 0-1.932-3.073 7.867 7.867 0 0 1-8.34 0c-.318-.2-.674-.29-1.024-.278z"/>
                                    </svg>
                                </button>
                                <button
                                    type="button"
                                    :class="['share-link', 'share-link--max', 'social-publish-btn', `share-link--${socialIconStatus('max')}`]"
                                    title="Опубликовать в MAX"
                                    aria-label="Опубликовать в MAX"
                                    @click="openSocialDialog('max')"
                                >
                                    <svg class="share-link__icon" viewBox="0 0 1000 1000" aria-hidden="true">
                                        <defs>
                                            <linearGradient id="maxIconB">
                                                <stop offset="0" stop-color="#00f"/>
                                                <stop offset="1" stop-opacity="0"/>
                                            </linearGradient>
                                            <linearGradient id="maxIconA">
                                                <stop offset="0" stop-color="#4cf"/>
                                                <stop offset=".662" stop-color="#53e"/>
                                                <stop offset="1" stop-color="#93d"/>
                                            </linearGradient>
                                            <linearGradient id="maxIconC" x1="117.847" x2="1000" y1="760.536" y2="500" gradientUnits="userSpaceOnUse" href="#maxIconA"/>
                                            <radialGradient id="maxIconD" cx="-87.392" cy="1166.116" r="500" fx="-87.392" fy="1166.116" gradientTransform="rotate(51.356 1551.478 559.3)scale(2.42703433 1)" gradientUnits="userSpaceOnUse" href="#maxIconB"/>
                                        </defs>
                                        <rect width="1000" height="1000" fill="url(#maxIconC)" ry="249.681"/>
                                        <rect width="1000" height="1000" fill="url(#maxIconD)" ry="249.681"/>
                                        <path fill="#fff" fill-rule="evenodd" d="M508.211 878.328c-75.007 0-109.864-10.95-170.453-54.75-38.325 49.275-159.686 87.783-164.979 21.9 0-49.456-10.95-91.248-23.36-136.873-14.782-56.21-31.572-118.807-31.572-209.508 0-216.626 177.754-379.597 388.357-379.597 210.785 0 375.947 171.001 375.947 381.604.707 207.346-166.595 376.118-373.94 377.224m3.103-571.585c-102.564-5.292-182.499 65.7-200.201 177.024-14.6 92.162 11.315 204.398 33.397 210.238 10.585 2.555 37.23-18.98 53.837-35.587a189.8 189.8 0 0 0 92.71 33.032c106.273 5.112 197.08-75.794 204.215-181.95 4.154-106.382-77.67-196.486-183.958-202.574Z" clip-rule="evenodd"/>
                                    </svg>
                                </button>
                            </div>
                            <social-publish-dialog
                                v-model="socialDialogOpen"
                                :network="socialDialogNetwork"
                                :network-label="socialDialogLabel"
                                :news-id="editedItem.id"
                                :initial-text="socialPostText"
                                :article-url="newsPublicUrl"
                                :image-url="shareImageUrl"
                                :text-limit="socialDialogTextLimit"
                                :status="socialDialogStatus"
                                @published="onSocialPublished"
                            ></social-publish-dialog>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="previewNews"
                            >
                                Предпросмотр
                            </v-btn>
                            <v-btn
                                v-if="editedIndex !== -1 && editedItem.exclusive && $store.state.auth.admin"
                                color="deep-purple"
                                dark
                                class="mr-4"
                                @click="openModerateDialog"
                            >
                                Модерация новости
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="closeEdit"
                            >
                                Отмена
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="save"
                            >
                                Сохранить
                            </v-btn>
                        </v-card-actions>
                    </v-card>

                    <file-uploader ref="uploader" />
                </v-dialog>

                <v-dialog
                v-model="dialogRemove"
                max-width="500px"
                >
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Удаление новости</span>
                        </v-card-title>

                        <v-card-text>Вы действительно хотите удалить указанную новость?</v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="closeRemove"
                            >
                                Отмена
                            </v-btn>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="removeItem(itemToRemove)"
                            >
                                Удалить
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog
                    v-model="dialogModerate"
                    persistent
                    max-width="500px"
                >
                    <v-card>
                        <v-card-title>
                            <span class="text-h5">Модерация новости</span>
                        </v-card-title>

                        <v-card-text>Выберете действие для новости</v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="moderate(2)"
                            >
                                Опубликовать
                            </v-btn>
                            <v-btn
                                color="red darken-1"
                                text
                                @click="moderate(3)"
                            >
                                Не опубликовывать
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </template>

            
            <template #[`item.actions`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                    title="Изменить новость"
                >
                    $pencil
                </v-icon>
                <v-icon
                    small
                    class="mr-2"
                    @click="openRemoveDialog(item)"
                    title="Удалить новость"
                >
                    $delete
                </v-icon>
            </template>
            <template #[`item.hide`]="{ item }"><v-icon small v-if="item.hide">$check</v-icon></template>
        </v-data-table>
    </div>
</template>

<script>
import FileUploader from "@c/FileUploader.vue";
import ContentEditor from "@c/ContentEditor.vue";
import SocialPublishDialog from "@c/SocialPublishDialog.vue";
import { createTempContentId } from "../utils/tempContentId";

const SOCIAL_NETWORK_LABELS = {
    telegram: 'Telegram',
    max: 'MAX',
    vk: 'VK',
    ok: 'Одноклассниках'
};
// Content::TYPE_TEXT на бэкенде - блок обычного текста в конструкторе новости
const CONTENT_TYPE_TEXT = 3;
const SOCIAL_TEXT_LIMITS = {
    telegram: 1024,
    max: 4000,
    vk: 16000,
    ok: 32000
};
// В эти сети уходит весь текст новости, в остальные - только первый абзац
// (у Telegram подпись ограничена 1024, MAX тоже держим коротким).
const SOCIAL_FULL_TEXT_NETWORKS = ['vk', 'ok'];

export default {
    name: "News",
    components: {
        ContentEditor,
        FileUploader,
        SocialPublishDialog
    },
    data() {
        return {
            query: '',
            dialogSource: false,
            onlyHidden: false,
            onlyPostponed: false,
            listMode: 0,
            list: [],
            cities: [],
            // функция выбора города при публикации новости отключена по просьбе заказчика;
            // чтобы вернуть - поставить true (бэкенд снова начнёт требовать city_ids)
            cityFeatureEnabled: false,
            tags: [],
            user: 0,
            datePubDialog: false,
            page: 1,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['id']
            },
            headers: [
                {
                    value: "id",
                    text: "ID",
                    sortable: false,
                },
                {
                    value: "name",
                    text: "Заголовок",
                    sortable: false,
                },
                {
                    value: "tags_string",
                    text: "Теги",
                    sortable: false,
                },
                {
                    value: "datePub",
                    text: "Дата",
                    sortable: false,
                },
                {
                    value: "views",
                    text: "Просмотры",
                    sortable: false,
                },
                {
                    value: "postpone",
                    text: "Отложена",
                    sortable: false,
                },
                {
                    value: "user_string",
                    text: "Пользователь",
                    sortable: false,
                },
                {
                    value: "indexShow",
                    text: "Главное",
                    sortable: false,
                },
                {
                    value: "hide",
                    text: "Скрыть?",
                    sortable: false,
                },
                {
                    value: 'actions',
                    text: 'Действия',
                    sortable: false,
                    align: 'end',
                },
            ],
            loading: false,
            pg: 1,
            totalCount: -1,
            hasNext: false,
            dialogEdit: false,
            defaultItem: {},
            defaultSource: {},
            editedIndex: -1,
            editedItem: {
                id: -1,
                name: '',
                description: '',
                tags: [],
                preview: '',
                newPreview: '',
                previewCaption: '',
                datePub: null,
                timezone: 'Asia/Krasnoyarsk',
                postpone: false,
                cities: [],
                userId: -1,
                hide: false,
                source: {
                    text: '',
                    link: ''
                },
                content: [],
                indexShow: false,
                otherNews: false,
                exclusive: false,
                creator: null,
                avatar: '',
                newAvatar: ''
            },
            dialogRemove: false,
            itemToRemove: -1,
            dialogModerate: false,
            curTab: null,
            socialDialogOpen: false,
            socialDialogNetwork: 'telegram',
            socialStatuses: {}
        };
    },
    watch: {
        options(pagination) {
            this.page = pagination.page;
            this.getList(pagination.page);
        },
        dialogEdit (val) {
            val || this.closeEdit();
        },
        dialogRemove (val) {
            val || this.closeRemove();
        },
        dialogModerate (val) {
            val || this.closeModerate();
        }
    },
    mounted() {
        this.defaultItem = Object.assign({}, this.editedItem);
        this.getCities();
        this.getTags();
        this.getUser();
    },
    computed: {
        canShareEditedNews () {
            return this.editedIndex !== -1 && Boolean(this.editedItem && this.editedItem.id);
        },
        newsPublicUrl () {
            if (!this.canShareEditedNews) {
                return '';
            }

            const slugPart = this.editedItem.slug ? `-${this.editedItem.slug}` : '';

            return `${this.getFrontPreviewOrigin()}/news/${this.editedItem.id}${slugPart}`;
        },
        shareTitle () {
            return this.editedItem && this.editedItem.name ? this.editedItem.name : '';
        },
        shareImageUrl () {
            return this.editedItem && this.editedItem.preview
                ? `${this.$store.state.api}${this.editedItem.preview}`
                : '';
        },
        socialLeadParagraph () {
            const blocks = Array.isArray(this.editedItem.content) ? this.editedItem.content : [];
            const ordered = blocks.slice().sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0));

            for (const block of ordered) {
                if (parseInt(block.type) !== CONTENT_TYPE_TEXT) {
                    continue;
                }

                const raw = block.data && typeof block.data.value === 'string' ? block.data.value : '';
                const lead = this.extractFirstParagraph(raw);

                if (lead) {
                    return lead;
                }
            }

            // новость без текстового блока (например, только фото/видео) - берём краткое описание
            return this.editedItem.description || '';
        },
        socialFullText () {
            const blocks = Array.isArray(this.editedItem.content) ? this.editedItem.content : [];
            const ordered = blocks.slice().sort((a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0));

            const chunks = [];
            for (const block of ordered) {
                if (parseInt(block.type) !== CONTENT_TYPE_TEXT) {
                    continue;
                }

                const raw = block.data && typeof block.data.value === 'string' ? block.data.value : '';
                const chunk = this.htmlBlocksToText(raw);

                if (chunk) {
                    chunks.push(chunk);
                }
            }

            return chunks.join('\n\n') || this.editedItem.description || '';
        },
        socialPostText () {
            const body = SOCIAL_FULL_TEXT_NETWORKS.includes(this.socialDialogNetwork)
                ? this.socialFullText
                : this.socialLeadParagraph;
            const parts = [this.shareTitle, body].filter(Boolean);

            return parts.join('\n\n');
        },
        socialDialogLabel () {
            return SOCIAL_NETWORK_LABELS[this.socialDialogNetwork] || this.socialDialogNetwork;
        },
        socialDialogTextLimit () {
            return SOCIAL_TEXT_LIMITS[this.socialDialogNetwork] || 4000;
        },
        socialDialogStatus () {
            return this.socialStatuses[this.socialDialogNetwork] || null;
        },
        getPostponeDate () {
            const raw = this.editedItem.datePub;
            if (!raw) {
                return '';
            }
            const d = raw instanceof Date ? raw : new Date(String(raw).replace(' ', 'T'));
            if (isNaN(d.getTime())) {
                return '';
            }
            return d.toLocaleString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formTitle () {
            return this.editedIndex === -1 ? 'Новая новость' : 'Редактирование новости #' + this.editedItem.id;
        },
    },
    methods: {
        async search () {
            await this.getList();
        },
        onListModeChange (value) {
            this.listMode = value;
            this.onlyPostponed = value === 1;
            this.page = 1;
            this.options.page = 1;
            this.getList(1);
        },
        onOpenSource () {
            this.defaultSource = Object.assign({}, this.editedItem.source);
        },
        onCancelSource () {
            this.editedItem.source = Object.assign({}, this.defaultSource);
            this.dialogSource = false;
        },
        resetDate() {
            // при включении отложенной публикации подставляем ближайший разумный
            // слот (через час, ровно по минутам), при выключении - очищаем
            this.editedItem.datePub = this.editedItem.postpone ? this.defaultPostponeDate() : null;
        },
        defaultPostponeDate() {
            const d = new Date();
            d.setHours(d.getHours() + 1, 0, 0, 0);
            return d;
        },
        async getList(pg = 1) {
            this.loading = true;
            try {
                const requestParams = {
                    pg,
                    on: this.options.itemsPerPage,
                    hide: this.onlyHidden,
                    withOutPostpone: this.onlyPostponed ? 0 : 1,
                    onlyPostponed: this.onlyPostponed ? 'true' : 'false',
                    fromAdmin: true,
                    query: this.query
                };

                const { list, hasNext, totalCount } = await this.$api(`/news?${new URLSearchParams(requestParams)}`);

                list.forEach((singleNew, index) => {
                    let city_names = [];

                    singleNew.cities.forEach((city) => {
                        city_names.push(city.name);
                    });

                    list[index].city_string = city_names.join(', ');

                    let tag_names = [];

                    singleNew.tags.forEach((tag) => {
                        tag_names.push(tag.name);
                    });

                    list[index].tags_string = tag_names.join(', ');

                    list[index].user_string = "[" + singleNew.user.id + "] " + singleNew.user.login;
                });

                this.list = list;
                this.hasNext = hasNext;
                this.pg = pg;
                this.totalCount = totalCount;
            } catch (e) {
                this.$error(e.message);
            }

            this.loading = false;
        },
        async getCities() {
            try {
                const { list } = await this.$api("/cities");

                this.cities = list;
            } catch (e) {
                this.$error(e.message);
            }
        },
        async getTags() {
            try {
                const { list } = await this.$api("/tags");

                this.tags = list;
            } catch (e) {
                this.$error(e.message);
            }
        },
        async getUser() {
            try {
                let userId = await this.$api("/current");
                this.user = userId.id;
            } catch (e) {
                this.$error(e.message);
            }
        },
        async editItem (item) {
            this.editedIndex = await this.list.indexOf(item);
            this.defaultItem = Object.assign({}, this.editedItem);
            try {
                let r = await this.$api(`/news/${item.id}`);
                this.editedItem = Object.assign({}, r);
                this.editedItem.timezone = 'Asia/Krasnoyarsk';
                // дату отложенной новости приводим к Date, чтобы работали и пикер,
                // и отображение, и проверка "в будущем" перед сохранением;
                // у уже опубликованной новости оставляем исходную дату как есть,
                // иначе бэкенд перезапишет её текущим временем при сохранении
                this.editedItem.datePub = r.postpone && r.datePub
                    ? new Date(String(r.datePub).replace(' ', 'T'))
                    : (r.datePub || null);

                const previewBlock = (r.content || []).find(c => parseInt(c.type) === 5 && c.data && c.data.previewSync);
                this.editedItem.previewCaption = previewBlock && previewBlock.data.value ? (previewBlock.data.value.text || '') : '';

                this.dialogEdit = true;
                this.fetchSocialStatuses(item.id);
            } catch (e) {
                this.$error(e.message);
            }
        },
        async fetchSocialStatuses (newsId) {
            this.socialStatuses = {};
            try {
                this.socialStatuses = await this.$api(`/admin/news/social-status/${newsId}`);
            } catch (e) {
                // покраска иконок не критична, просто оставляем их серыми
            }
        },
        /**
         * Первый непустой абзац текстового блока в виде простого текста.
         * Блок хранится как HTML из редактора ("<p>...</p><p>...</p>"), а в соцсети
         * уходит plain text (разметку накладывает уже паблишер на бэкенде), поэтому
         * теги снимаем, а сущности вроде &nbsp; раскрываем через браузерный парсер.
         */
        extractFirstParagraph (rawHtml) {
            if (!rawHtml) {
                return '';
            }

            const paragraphs = rawHtml.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [rawHtml];

            for (const paragraph of paragraphs) {
                // DOMParser даёт инертный документ: скрипты не выполняются и картинки
                // не грузятся, в отличие от innerHTML во временном div
                const doc = new DOMParser().parseFromString(paragraph.replace(/<br\s*\/?>/gi, ' '), 'text/html');
                const text = (doc.body.textContent || '').replace(/\s+/g, ' ').trim();

                if (text) {
                    return text;
                }
            }

            return '';
        },
        /**
         * Весь текст блока в виде простого текста с сохранением абзацев.
         * Блочные элементы (абзацы, заголовки, пункты списков) разделяются
         * пустой строкой; внутри элемента пробелы схлопываются. Разметку в
         * соцсети накладывает уже паблишер на бэкенде, поэтому теги снимаем.
         */
        htmlBlocksToText (rawHtml) {
            if (!rawHtml) {
                return '';
            }

            const doc = new DOMParser().parseFromString(
                String(rawHtml).replace(/<br\s*\/?>/gi, '\n'),
                'text/html'
            );
            const blockSelector = 'p, h1, h2, h3, h4, h5, h6, li, blockquote, pre';
            const nodes = doc.body.querySelectorAll(blockSelector);
            const lines = [];

            const clean = (value) => (value || '')
                .replace(/[^\S\n]+/g, ' ')
                .replace(/ *\n */g, '\n')
                .trim();

            if (nodes.length) {
                nodes.forEach((node) => {
                    // контейнеры со вложенными блоками (blockquote > p, вложенные
                    // списки) пропускаем - их текст возьмём с внутренних элементов
                    if (node.querySelector(blockSelector)) {
                        return;
                    }

                    const text = clean(node.textContent);
                    if (text) {
                        lines.push(text);
                    }
                });
            } else {
                const text = clean((doc.body.textContent || '').replace(/\s+/g, ' '));
                if (text) {
                    lines.push(text);
                }
            }

            return lines.join('\n\n');
        },
        openSocialDialog (network) {
            this.socialDialogNetwork = network;
            this.socialDialogOpen = true;
        },
        onSocialPublished (result) {
            this.$set(this.socialStatuses, this.socialDialogNetwork, result);
        },
        socialIconStatus (network) {
            const s = this.socialStatuses[network];
            if (!s) {
                return 'none';
            }

            return s.status === 'success' ? 'success' : 'error';
        },
        openRemoveDialog (item) {
            this.itemToRemove = item;
            this.dialogRemove = true;
        },
        openModerateDialog () {
            this.dialogModerate = true;
        },
        async removeItem (item) {
            try {
                let r = await this.$api(`/admin/news/${item.id}`, {
                    method: "DELETE"
                });
                if (!r.error) {
                    this.getList();
                    this.closeRemove();
                }
            } catch (e) {
                this.$error(e.message);
            }
        },
        closeRemove () {
            this.dialogRemove = false;
            this.$nextTick(() => {
                this.itemToRemove = -1;
            });
        },
        closeModerate () {
            this.dialogModerate = false;
        },
        closeEdit () {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem, {
                    content: [],
                    source: {
                        text: '',
                        link: ''
                    }
                });
                this.editedIndex = -1;
                this.socialStatuses = {};
            });
        },
        async uploadPreview() {
            if (this.editedItem.newPreview) {
                const needUpload = [];

                this.editedItem.newPreview.id = this.editedItem.id;
                needUpload.push(this.editedItem.newPreview);
                delete this.editedItem.newPreview;

                const files = await this.$refs.uploader.upload(needUpload);

                for (let f of files) {
                    if (f.id == this.editedItem.id) {
                        let fileData = {
                            tmp: f.tmp,
                            name: f.name,
                            size: Math.ceil(f.size / 1024 / 1024),
                            type: f.type.split('/')[1]
                        };
                        return fileData;
                    }
                }
            }
            return false;
        },
        async uploadAvatar() {
            if (this.editedItem.newAvatar) {
                const needUpload = [];

                this.editedItem.newAvatar.id = this.editedItem.id;
                needUpload.push(this.editedItem.newAvatar);
                delete this.editedItem.newAvatar;

                const files = await this.$refs.uploader.upload(needUpload);

                for (let f of files) {
                    if (f.id == this.editedItem.id) {
                        let fileData = {
                            tmp: f.tmp,
                            name: f.name,
                            size: Math.ceil(f.size / 1024 / 1024),
                            type: f.type.split('/')[1]
                        };
                        return fileData;
                    }
                }
            }
            return false;
        },
        async uploadContent() {
            if (this.editedItem.content) {
                for (let block of this.editedItem.content) {
                    const needUpload = []; 
                    let value = null;
                    let imageText = null;

                    if (block.id < 0) {
                        switch (parseInt(block.type)) {
                            case 5:
                            case 6:
                                value = block.data.value.newValue ?? block.data.value.file;
                                if (block.type == 5) {
                                    if (block.data.value.text) {
                                        imageText = block.data.value.text;
                                    } 
                                }
                                
                                // если нового файла нет, то пропускаем загрузку
                                if (!(value instanceof File)) {
                                    break;
                                }
                                value.blockType = block.type;
                                needUpload.push(value);
                                delete block.data.value;
                                delete block.data.newValue;
                                break;
                            case 7:
                            case 8:
                                block.data.value.list.map((item, index) => {
                                    item.blockType = block.type;
                                    item.id = index;
                                    
                                    if (!(item instanceof File)) {
                                        return;
                                    }
                                    needUpload.push(item);
                                });
                                // если новоых файлов нет, то пропускаем загрузку
                                if (needUpload.length < 1) {
                                    break;
                                }
                                
                                delete block.data.value.list;
                                break;
                        }
                    }

                    if (needUpload.length > 0) {
                        const files = await this.$refs.uploader.upload(needUpload);
                        for (let f of files) {
                            let fileData = null;
                            if (f.blockType == 5) {
                                fileData = {
                                    file: {
                                        tmp: f.tmp,
                                        name: f.name,
                                        size: Math.ceil(f.size / 1024 / 1024),
                                        type: f.type.split('/')[1]
                                    },
                                    text: imageText
                                };
                            } else {
                                fileData = {
                                    tmp: f.tmp,
                                    name: f.name,
                                    size: Math.ceil(f.size / 1024 / 1024),
                                    type: f.type.split('/')[1]
                                };
                            }
                            
                            if (f.blockType == 7 || f.blockType == 8) {
                                if (!Object.hasOwnProperty.call(block.data.value, 'list')) {
                                    block.data.value.list = [];
                                }
                                block.data.value.list.push(fileData);
                            } else {
                                block.data.value = fileData;
                            }
                            
                        }
                    }
                }
            }
            return false;
        },
        findPreviewSyncedContentIndex () {
            if (!Array.isArray(this.editedItem.content)) {
                return -1;
            }

            return this.editedItem.content.findIndex(item => parseInt(item.type) === 5 && item.data && item.data.previewSync);
        },
        getPreviewSyncedFileData () {
            const previewPath = this.editedItem.preview || '';
            const previewName = this.editedItem.newPreview ? this.editedItem.newPreview.name : (previewPath.split('/').pop() || 'poster.jpg');
            const previewType = this.editedItem.newPreview && this.editedItem.newPreview.type
                ? this.editedItem.newPreview.type.split('/').pop()
                : (previewName.split('.').pop() || 'jpg');
            const previewSize = this.editedItem.newPreview && this.editedItem.newPreview.size
                ? Math.ceil(this.editedItem.newPreview.size / 1024 / 1024)
                : 0;

            return {
                name: previewName,
                size: previewSize,
                type: previewType
            };
        },
        syncPreviewWithContent () {
            if (!Array.isArray(this.editedItem.content)) {
                this.editedItem.content = [];
            }

            const previewBlockIndex = this.findPreviewSyncedContentIndex();
            const hasPreview = Boolean(this.editedItem.newPreview || this.editedItem.preview);

            if (!hasPreview) {
                if (previewBlockIndex > -1) {
                    this.editedItem.content.splice(previewBlockIndex, 1);
                }

                return;
            }

            const previewFile = this.getPreviewSyncedFileData();

            if (previewBlockIndex > -1) {
                const block = this.editedItem.content[previewBlockIndex];

                block.data = Object.assign({}, block.data, {
                    image: this.editedItem.preview || '',
                    previewSync: true,
                    value: {
                        file: previewFile,
                        text: this.editedItem.previewCaption || ''
                    }
                });

                return;
            }

            this.editedItem.content.unshift({
                id: createTempContentId(),
                type: 5,
                data: {
                    image: this.editedItem.preview || '',
                    previewSync: true,
                    value: {
                        file: previewFile,
                        text: this.editedItem.previewCaption || ''
                    }
                }
            });
        },
        getPreviewDraftId () {
            return `news-preview-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
        },
        getFrontPreviewOrigin () {
            const { protocol, hostname } = window.location;

            if (hostname === 'admin.adi19.ru') {
                return `${protocol}//adi19.ru`;
            }

            if (hostname.endsWith('.dock')) {
                return `${protocol}//adi19-front.dock:23000`;
            }

            if (hostname === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
                return `${protocol}//${hostname}:23000`;
            }

            return `${protocol}//${hostname.replace(/^admin\./, '')}`;
        },
        getPreviewStorageKey (draftId) {
            return `adi19:news-preview:${draftId}`;
        },
        async readFileAsDataUrl (file) {
            if (!(file instanceof File)) {
                return file;
            }

            return await new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => resolve(reader.result);
                reader.onerror = () => reject(new Error(`Не удалось прочитать файл ${file.name}`));
                reader.readAsDataURL(file);
            });
        },
        async mapPreviewFileList (list = []) {
            const result = [];

            for (const item of list) {
                if (item instanceof File) {
                    result.push({
                        image: await this.readFileAsDataUrl(item),
                        saved: await this.readFileAsDataUrl(item),
                        name: item.name,
                        size: Math.ceil(item.size / 1024 / 1024),
                        type: (item.name.split('.').pop() || '').toLowerCase()
                    });
                    continue;
                }

                result.push(Object.assign({}, item));
            }

            return result;
        },
        clonePreviewContentBlock (block) {
            return {
                ...block,
                data: block && block.data
                    ? {
                        ...block.data,
                        value: block.data.value && typeof block.data.value === 'object'
                            ? Array.isArray(block.data.value)
                                ? [...block.data.value]
                                : Object.keys(block.data.value).reduce((acc, key) => {
                                    const value = block.data.value[key];

                                    acc[key] = Array.isArray(value)
                                        ? [...value]
                                        : value;

                                    return acc;
                                }, {})
                            : block.data.value
                    }
                    : block.data
            };
        },
        async buildPreviewContent (previewImage) {
            const content = (this.editedItem.content || []).map(block => this.clonePreviewContentBlock(block));

            for (const block of content) {
                if (!block || !block.data) {
                    continue;
                }

                switch (parseInt(block.type)) {
                    case 5: {
                        const rawImageFile = block.data.value && (block.data.value.newValue || block.data.value.file);
                        const nextImage = block.data.previewSync && previewImage
                            ? previewImage
                            : rawImageFile instanceof File
                                ? await this.readFileAsDataUrl(rawImageFile)
                                : block.data.image;

                        block.data.image = nextImage || '';
                        block.data.value = Object.assign({}, block.data.value, {
                            text: block.data.value && block.data.value.text ? block.data.value.text : ''
                        });
                        break;
                    }
                    case 6: {
                        const rawVideoFile = block.data.value && (block.data.value.newValue || block.data.value.file);

                        block.data.video = rawVideoFile instanceof File
                            ? await this.readFileAsDataUrl(rawVideoFile)
                            : block.data.video;
                        break;
                    }
                    case 7:
                    case 8:
                        block.data.value = Object.assign({}, block.data.value, {
                            list: await this.mapPreviewFileList(block.data.value && block.data.value.list ? block.data.value.list : [])
                        });
                        break;
                }
            }

            return content;
        },
        async buildPreviewPayload () {
            const preview = this.editedItem.newPreview instanceof File
                ? await this.readFileAsDataUrl(this.editedItem.newPreview)
                : this.editedItem.preview;
            const avatar = this.editedItem.newAvatar instanceof File
                ? await this.readFileAsDataUrl(this.editedItem.newAvatar)
                : this.editedItem.avatar;
            const content = await this.buildPreviewContent(preview || '');

            return {
                id: this.editedItem.id > 0 ? this.editedItem.id : `preview-${Date.now()}`,
                name: this.editedItem.name || 'Без заголовка',
                description: this.editedItem.description || '',
                preview: preview || '',
                datePub: this.editedItem.datePub || new Date(),
                tags: (this.editedItem.tags || []).map(tag => tag.id ? tag : this.tags.find(item => item.id === tag) || { id: tag, name: `Тег #${tag}` }),
                content,
                source: this.editedItem.source || { text: '', link: '' },
                exclusive: this.editedItem.exclusive,
                creator: this.editedItem.creator,
                avatar: avatar || '',
                previewMode: true
            };
        },
        async previewNews () {
            try {
                this.syncPreviewWithContent();

                const token = this.$store.state.auth.token;

                if (!token) {
                    this.$error('Не найден токен авторизации администратора');
                    return;
                }

                const draftId = this.getPreviewDraftId();
                const previewOrigin = this.getFrontPreviewOrigin();
                const previewUrl = `${previewOrigin}/news/preview?draftId=${encodeURIComponent(draftId)}`;
                const previewWindow = window.open(previewUrl, '_blank');

                if (!previewWindow) {
                    this.$error('Браузер заблокировал новую вкладку предпросмотра');
                    return;
                }

                const payload = {
                    type: 'ADI19_NEWS_PREVIEW_INIT',
                    draftId,
                    storageKey: this.getPreviewStorageKey(draftId),
                    token,
                    news: await this.buildPreviewPayload()
                };

                let attempt = 0;
                const maxAttempts = 20;
                const timer = window.setInterval(() => {
                    attempt += 1;
                    previewWindow.postMessage(payload, previewOrigin);

                    if (attempt >= maxAttempts) {
                        window.clearInterval(timer);
                    }
                }, 300);
            } catch (e) {
                this.$error(e.message);
            }
        },
        async save () {
            this.syncPreviewWithContent();

            if (!this.editedItem.name) {
                this.$error('Поле "заголовок" обязательно');
                return;
            }
            if (!this.editedItem.description) {
                this.$error('Поле "краткое описание" обязательно');
                return;
            }
            if (this.editedItem.tags.length < 1) {
                this.$error('Поле "категории" обязательно');
                return;
            }
            if ((this.editedItem.source.text && !this.editedItem.source.link)) {
                this.$error('Укажите ссылку на источник');
                return;
            }
            if ((!this.editedItem.source.text && this.editedItem.source.link)) {
                this.$error('Укажите текст источника');
                return;
            }
            
            if (this.cityFeatureEnabled && this.editedItem.cities.length < 1) {
                this.$error('Поле "города" обязательно');
                return;
            }
            if (this.editedItem.content.length < 1) {
                this.$error('Контент не может быть пустым');
                return;
            }

            if (this.editedItem.postpone) {
                const raw = this.editedItem.datePub;
                const d = raw instanceof Date ? raw : new Date(String(raw || '').replace(' ', 'T'));
                if (!raw || isNaN(d.getTime())) {
                    this.$error('Укажите дату и время отложенной публикации');
                    return;
                }
                if (d.getTime() <= Date.now()) {
                    this.$error('Дата отложенной публикации должна быть в будущем');
                    return;
                }
            }

            // Эксклюзив — авторский материал: имя автора обязательно всегда,
            // аватар — только при создании (у уже сохранённой новости форма
            // загруженную картинку повторно не отправляет).
            if (this.editedItem.exclusive && !this.editedItem.creator) {
                this.$error('У Эксклюзива должен быть автор');
                return;
            }

            if (this.editedIndex == -1 && this.editedItem.exclusive && !this.editedItem.newAvatar) {
                this.$error('У Эксклюзива должен быть аватар автора');
                return;
            }

            let previewAvatar = [];
            if (this.editedItem.newAvatar) {
                previewAvatar = await this.uploadAvatar();
            }

            let previewFile = [];
            if (this.editedItem.newPreview) {
                previewFile = await this.uploadPreview();
            }
            await this.uploadContent();
            let c_ids = []; 
            this.editedItem.cities.forEach((city) => {
                if (city.id) {
                    c_ids.push(city.id);
                } else {
                    c_ids.push(city);
                }
            });

            let t_ids = []; 
            this.editedItem.tags.forEach((tag) => {
                if (tag.id) {
                    t_ids.push(tag.id);
                } else {
                    t_ids.push(tag);
                }
            });
            
            this.editedItem.content.forEach(item => {
                if (item.type == 9) {
                    if (item.data.value.answers.length < 1) {
                        throw this.$error(`У Вас пустой опрос. "${item.data.value.title}"`);
                    }
                }
            });
            
            if (this.editedIndex > -1) {
                try {
                    let r = await this.$api("/admin/news/" + this.editedItem.id, {
                        method: "PUT",
                        body: {
                            name: this.editedItem.name,
                            description: this.editedItem.description,
                            source: this.editedItem.source,
                            postpone: this.editedItem.postpone ? 1 : 0,
                            datePub: this.editedItem.datePub,
                            city_ids: c_ids,
                            tag_ids: t_ids,
                            hide: this.editedItem.hide,
                            user_id: this.user,
                            poster: previewFile.tmp ?? [],
                            content: this.editedItem.content,
                            indexShow: this.editedItem.indexShow,
                            otherNews: this.editedItem.otherNews,
                            exclusive: this.editedItem.exclusive,
                            avatar: previewAvatar.tmp ?? [],
                            creator: this.editedItem.creator
                        },
                    });
                    if (!r.error) {
                        this.getList();
                        this.closeEdit();
                    }
                } catch (e) {
                    this.$error(e.message);
                }
            } else {
                try {
                    let r = await this.$api("/admin/news/add", {
                        method: "POST",
                        body: {
                            name: this.editedItem.name,
                            description: this.editedItem.description,
                            source: this.editedItem.source,
                            postpone: this.editedItem.postpone ? 1 : 0,
                            datePub: this.editedItem.datePub,
                            city_ids: c_ids,
                            tag_ids: t_ids,
                            hide: this.editedItem.hide,
                            user_id: this.user,
                            poster: previewFile.tmp ?? [],
                            content: this.editedItem.content,
                            indexShow: this.editedItem.indexShow,
                            otherNews: this.editedItem.otherNews,
                            exclusive: this.editedItem.exclusive,
                            avatar: previewAvatar.tmp ?? [],
                            creator: this.editedItem.creator
                        },
                    });
                    if (!r.error) {
                        this.getList();
                        this.closeEdit();
                    }
                } catch (e) {
                    this.$error(e.message);
                }
            }
        },
        async moderate (status) {
            if (this.editedItem < 0) {
                throw this.$error('Нельзя модерировать новую новость');
            }
            try {
                let r = await this.$api("/admin/news/moderate/" + this.editedItem.id, {
                    method: "PATCH",
                    body: {
                        status
                    },
                });
                if (!r.error) {
                    this.$success('Новость успешно прошла модерацию');
                    this.getList();
                    this.closeModerate();
                    this.closeEdit();
                }
            } catch (e) {
                this.$error(e.message);
            }
        }
    }
};
</script>

<style scoped>
    /* Форма новости: вертикальные поля блоков втрое меньше стандартных 24px —
       иначе между полями и чекбоксами слишком много пустоты и форма не влезает
       на экран. Боковые оставляем как есть. */
    /* Заголовок крупнее и жирнее анонса — чтобы взгляд их различал. */
    .news-title-field ::v-deep input {
        font-size: 1.15rem;
        font-weight: 600;
    }

    .news-edit-dialog-card ::v-deep .v-card__text {
        /* !important — иначе перебивает глобальное правило .v-card .v-card__text из App.vue */
        padding-top: 8px !important;
        padding-bottom: 8px !important;
    }

    .news-edit-dialog-card {
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - 48px);
    }

    /* Четыре флага в один ряд: у Vuetify чекбокс тянет верхний отступ от текстовых полей. */
    .news-flags ::v-deep .v-input--checkbox {
        margin-top: 0;
        margin-right: 24px;
    }

    .news-flags ::v-deep .v-input--checkbox:last-child {
        margin-right: 0;
    }

    /*
     * Заголовок диалога («Редактирование новости #N») — служебная строка, крупный
     * размер из глобальных стилей ей ни к чему. Ужимаем шрифт и отступы примерно вдвое.
     * Двойной класс .v-card__title.v-card__title нужен, чтобы перебить глобальные
     * правила из App.vue (.v-dialog .v-card .v-card__title{...!important}) без гонки за порядком.
     */
    .news-edit-dialog-card >>> .v-card__title.v-card__title {
        padding: 6px 16px !important;
        min-height: 0 !important;
    }

    .news-edit-dialog-card >>> .v-card__title .text-h5 {
        font-size: 0.9rem !important;
        line-height: 1.3 !important;
        font-weight: 600 !important;
    }

    .news-edit-dialog-content {
        overflow-y: auto;
        flex: 1 1 auto;
    }

    .date-picker {
        border: none;
    }

    .share-link {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #1976d2;
        text-decoration: none;
        opacity: 0.9;
    }

    .share-link:hover {
        opacity: 1;
        text-decoration: none;
    }

    /*
     * Иконки соцсетей вынесены в свой флекс-контейнер: в v-card-actions глобальное
     * мобильное правило (App.vue) ставит flex-direction: column-reverse, из-за чего
     * кнопки-иконки вставали вертикальным столбиком. Обёртка становится ОДНИМ элементом
     * этой колонки, а внутри неё иконки остаются в горизонтальном ряду.
     */
    .social-share-row {
        display: flex;
        align-items: center;
        gap: 8px;
        /* не даём обёртке схлопнуться до min-content в строке действий (иначе иконки
           переносятся вертикально из-за min-width:auto флекс-элемента) */
        flex-shrink: 0;
    }

    .social-publish-btn {
        border: none;
        background: none;
        cursor: pointer;
        padding: 0;
    }

    .share-link--brand-vk {
        color: #4680c2;
    }

    .share-link--brand-telegram {
        color: #0088cc;
    }

    .share-link--brand-ok {
        color: #ed812b;
    }

    .share-link--success {
        color: #2e7d32;
    }

    .share-link--error {
        color: #c62828;
    }

    .share-link__icon {
        width: 24px;
        height: 24px;
        display: block;
    }

    .share-link--max {
        width: 24px;
        height: 24px;
        border-radius: 7px;
        border: 2px solid currentColor;
        padding: 1px;
    }

    /*
     * На телефоне увеличиваем область нажатия иконок до комфортных 40px.
     * Блок стоит в конце, чтобы переопределить фиксированную ширину .share-link--max выше.
     */
    @media (max-width: 600px) {
        .social-share-row {
            gap: 12px;
            margin-bottom: 0;
        }

        .social-publish-btn {
            width: 40px;
            height: 40px;
            padding: 0;
        }

        .share-link--max {
            width: 40px;
            height: 40px;
        }

        /* убираем лишний воздух под панелью действий (двойной класс — перебить App.vue) */
        .news-edit-dialog-card >>> .v-card__actions.v-card__actions {
            padding-bottom: 2px !important;
        }
    }
</style>
